module.exports = __webpack_public_path__ + "img/swipe.a3ed8f2f.gif";